module.exports = __webpack_public_path__ + "static/media/feedback-form.cf332209.svg";